import React from 'react';

export interface MessageBubbleProps {
    children: React.ReactNode;
    isAgent?: boolean;
}

const styles = {
    container: {
        display: 'inline-block',
        width: 'fit-content',
        padding: '8px 12px',
        borderRadius: '16px',
        fontSize: '14px',
        lineHeight: '1.4',
        whiteSpace: 'pre-wrap' as const,
        wordBreak: 'break-word' as const,
    },
    agent: {
        backgroundColor: '#6366f1',
        background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
        color: 'white',
        boxShadow: '0 2px 4px rgba(99,102,241,0.2)',
    },
    customer: {
        backgroundColor: '#ffffff',
        background: 'linear-gradient(135deg, #ffffff, #f9fafb)',
        color: '#111827',
        boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
        border: '1px solid #e5e7eb',
    }
};

export function MessageBubble({ children, isAgent = true }: MessageBubbleProps) {
    return (
        <div style={{
            ...styles.container,
            ...(isAgent ? styles.agent : styles.customer)
        }}>
            {children}
        </div>
    );
} 